
import React, { useEffect, useState } from "react";

import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import { saveAs } from "file-saver";
// import "./AllotmentLetter.css";
import { getAllotmentLetterData, getJdCompanyDetailsForUnit } from "../../Services/AllAllotments";
import { supabase } from "../../supabaseClient";

const VJ_RERA_NUMBER = "PR1260002501660";

const PNRDAllotmentLetter =({ allotment, onPdfGenerated }) => {


  const [parkingData, setParkingData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [pdfUrl, setPdfUrl] = useState(null);
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        console.log('allotment===============', allotment)
        if (allotment?.allotment_payment_id) {
          const data = await getAllotmentLetterData(
            allotment.allotment_payment_id
          );
          // JD/landowner units carry their JD project's RERA; loaded with the letter data so the
          // PDF (generated when parkingData changes) never renders with the VJ value first
          const jdCompany = await getJdCompanyDetailsForUnit(allotment?.project_id, allotment?.unit_id).catch(() => null);
          setParkingData(data ? { ...data, jdCompanyName: jdCompany?.companyName, jdReraNumber: jdCompany?.reraNumber } : data); // now data is already flat
          console.log("parkingData:", data);
        }
      } catch (err) {
        console.error("Error fetching allotment parking data", err);
      }
    };
    if (allotment?.allotment_payment_id) {
  fetchData();
}

  }, [ allotment]);

useEffect(() => {
  // if (!parkingData) return;

  (async () => {
    console.log("📄 Generating PDF with data:", parkingData);

    const pdfBytes = await generateAllotmentLetterPDFBytes();

    // Preview PDF
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    setPdfUrl(URL.createObjectURL(blob));

    // Send base64 to parent for email
    const base64 = btoa(
      new Uint8Array(pdfBytes).reduce(
        (data, byte) => data + String.fromCharCode(byte),
        ""
      )
    );

    onPdfGenerated?.(base64);
  })();
}, [parkingData]);
console.log("allotment:", allotment);
console.log("parkingData:", parkingData);



  // useEffect(() => {
  //   if (!open) return;

  //   if (!parkingData || Object.keys(parkingData).length === 0) {
  //     // console.log("⚠️ Parking data not ready, skipping PDF generation");
  //     return;
  //   }

  //   (async () => {
  //     console.log("📄 Generating PDF with data:", parkingData);
  //     const pdfBytes = await generateAllotmentLetterPDFBytes();
  //     const blob = new Blob([pdfBytes], { type: "application/pdf" });
  //     setPdfUrl(URL.createObjectURL(blob));
  //   })();
  // }, [open, parkingData]); // 👈 wait for parkingData

  // useEffect(() => {
  //   if (!open) return;
  //   (async () => {
  //     const pdfBytes = await generateAllotmentLetterPDFBytes();
  //     const blob = new Blob([pdfBytes], { type: "application/pdf" });
  //     const url = URL.createObjectURL(blob);
  //     setPdfUrl(url);
  //   })();
  // }, [open]);

const pdfBytesToBase64 = (pdfBytes) => {
  return btoa(
    new Uint8Array(pdfBytes).reduce(
      (data, byte) => data + String.fromCharCode(byte),
      ""
    )
  );
};





  const generateAllotmentLetterPDFBytes = async () => {
  const pdfDoc = await PDFDocument.create();
  let page = pdfDoc.addPage([595, 842]); // A4 page size
  const { height, width } = page.getSize();
  const italic = await pdfDoc.embedFont(StandardFonts.HelveticaOblique);
  const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
  const bold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

  const margin = 50;
  const fontSize = 10;
  const lineHeight = 14;
  let y = height - 50;

  // Add a new page if needed and ensure footer is drawn on every page
  const newPageIfNeeded = () => {
    if (y < 60) {
      page = pdfDoc.addPage([595, 842]); // A4 page size
      y = height - 50; // Reset y position to start from the top of the new page
    }
  };

  const drawText = (text, opts = {}) => {
    const { boldText = false, size = fontSize, x = margin } = opts;
    page.drawText(text, {
      x,
      y,
      size,
      font: boldText ? bold : font,
    });
    y -= lineHeight;
    newPageIfNeeded();
  };

  const drawParagraph = (text, opts = {}) => {
    if (!text) return;
    const clean = text.replace(/\n/g, " ");
    const words = clean.split(" ");
    let line = "";
    const startX = opts.x ?? margin;
    const maxWidth = width - startX - margin;

    words.forEach((word) => {
      const test = line + word + " ";
      const w = (opts.boldText ? bold : font).widthOfTextAtSize(test, fontSize);
      if (w > maxWidth) {
        page.drawText(line, {
          x: startX,
          y,
          size: fontSize,
          font: opts.boldText ? bold : font,
        });
        y -= lineHeight;
        newPageIfNeeded();
        line = word + " ";
      } else {
        line = test;
      }
    });

    if (line) {
      page.drawText(line, {
        x: margin,
        y,
        size: fontSize,
        font: opts.boldText ? bold : font,
      });
      y -= lineHeight;
      newPageIfNeeded();
    }
  };

  // ================= FOOTER NOTE =================
  const drawFooterNote = (page, font, fontSize, width) => {
    const footerNote = "* This is a system-generated allotment letter; no signature is required.";
    const noteWidth = font.widthOfTextAtSize(footerNote, fontSize);
    // const footerX = (width - noteWidth) / 2; // Center it
     const footerX = width - margin - noteWidth;
    page.drawText(footerNote, {
      x: footerX,
      y: 30, // Position it just above the bottom of the page
      size: fontSize,
      font: font,
    });
  };
// ================= HEADER (LEFT + RIGHT) =================
const rightX = width - margin - 200;

page.drawText(
  `Allotment No. ${parkingData?.unitNo || "«Primary Unit No»"}`,
  { x: margin, y, size: fontSize, font: bold }
);

page.drawText(
 `Date: ${new Date(allotment?.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) || "«Booking Date (Short)»"}`

,
  { x: rightX, y, size: fontSize, font: bold }
);

y -= 30;

// ================= TO + PAN (ROW 1) =================
page.drawText("To,", {
  x: margin,
  y,
  size: fontSize,
  font: bold,
});

page.drawText(
  `Pan Card No.: ${parkingData?.pan_number?.toUpperCase() || ""}`,
  {
    x: rightX,
    y,
    size: fontSize,
    font: bold,
  }
);

y -= lineHeight;

// ================= APPLICANT NAME =================
page.drawText(
  parkingData?.name || "",
  {
    x: margin,
    y,
    size: fontSize,
    font: bold,
  }
);

y -= lineHeight;

// ================= MOBILE =================
page.drawText(
  `Mobile No.: ${parkingData?.contactNumber || ""}`,
  {
    x: margin,
    y,
    size: fontSize,
    font: font,
  }
);

y -= 20;

// ================= CO-APPLICANT =================
// Co-Applicant Name (including middle name if available for second applicant)
page.drawText(
  `${parkingData?.applicants?.[1]?.applicant?.firstName || ""} ${parkingData?.applicants?.[1]?.applicant?.middleName ? parkingData.applicants[1].applicant.middleName : ""} ${parkingData?.applicants?.[1]?.applicant?.lastName || ""}`,
  {
    x: margin,
    y,
    size: fontSize,
    font: bold,
  }
);

// Co-Applicant PAN Card
// page.drawText(
//   `Pan Card No.: ${parkingData?.applicants?.[1]?.applicant?.panNumber || ""}`,
//   {
//     x: rightX,
//     y,
//     size: fontSize,
//     font: bold,
//   }
// );

y -= lineHeight; // Adjust line spacing

// Co-Applicant Mobile Number
// page.drawText(
//   `Mobile No.: ${parkingData?.applicants?.[1]?.applicant?.contactNumber || ""}`,
//   {
//     x: margin,
//     y,
//     size: fontSize,
//     font,
//   }
// );

y -= 20; // Adjust line spacing after the last line;

// ================= EMAIL =================
page.drawText(
  `Email ID: ${parkingData?.email || ""}`,
  {
    x: margin,
    y,
    size: fontSize,
    font,
  }
);

y -= 20;

// ================= ADDRESS =================
drawParagraph(
  `R/o: ${parkingData?.address || ""}`
);

y -= 20;

// ================= SUBJECT =================
drawParagraph(
  `Sub: Your request for allotment of Unit in the project known as “Pratik Nagar Palladio Kothrud Central”, having MahaRERA Registration No. PR1260002501660.`,
  { boldText: true }
);
y -= 20;
 drawText("Dear Sir/Madam ,", { boldText: true });

 // ================= SECTION 1 =================
y -= 10;
page.drawText("1. Allotment of the said Unit:", {
  x: margin,
  y,
  size: fontSize,
  font: bold,
});
y -= lineHeight;

// Full paragraph – exact legal text
drawParagraph(
  `This has reference to your request referred at the above subject. In that regard, I/we have the pleasure to inform that you have been allotted a commercial Unit/premises bearing No. ${
    parkingData?.unitNo || "«PRIMARY UNIT NO»"
  } admeasuring RERA Carpet area ${
    parkingData?.areaDifference || "«AREA 3»"
  } sq. mtrs. equivalent to ${parkingData?.areaDifferenceInSqFt || "«AREA 4»"} sq. ft. situated on ${
    parkingData?.floorNo || "«FLOOR NO»"
  } floor in Wing No. ${
    parkingData?.wingName || "«LEVEL 3»"
  } in the project known as “Pratik Nagar Palladio Kothrud Central”, having MahaRERA Registration No. ${parkingData?.jdReraNumber || VJ_RERA_NUMBER}, hereinafter referred to as “the said Unit”, being developed on project land admeasuring 13,878.09 Square Meters out of land admeasuring 14,467 Square Meters (as per Redevelopment Agreement) 14,246.62 Square Meters (as per Property Card) out of land bearing C.T.S. No.749 (P), (Old Survey No.137/1), Village: Kothrud, Taluka: Haveli, District: Pune and within the limits of Pune Municipal Corporation and within the jurisdiction of Sub-Registrar of Assurances, Haveli No.1 to 28, Pune for a total consideration of Rs. ${parkingData?.unitCost?.bsp} /- exclusive of GST, Stamp Duty and Registration Charges.`
);

  drawFooterNote(page, font, 8, width); 
 // ================= SECTION 2 =================
y -= 10;
page.drawText("2. Allotment of Garage/ Covered Parking Space(s):", {
  x: margin,
  y,
  size: fontSize,
  font: bold,
});
y -= lineHeight;

// Main paragraph
drawParagraph(
  `The Allottee hereby agrees to purchase from the Promoter and the Promoter hereby agrees to allot to the Allottee covered parking space/s, (if applicable) situated at ${parkingData?.parkingfloor} bearing No.${
    parkingData?.parkingNumber || "______"
  } admeasuring minimum 9.29 sq. mtrs. having ${
    parkingData?.parkingLength || "_______"
  } meters length x ${
    parkingData?.parkingBreadth || "__________"
  } meters breadth x ${
    parkingData?.parkingHeight || "______"
  } meters vertical clearance being constructed in the project. The Allottee/s hereby confirm and agrees that there may be deviation up to 20 CM from all dimensions of the parking based on the inputs/changes suggested by the structural engineer/ architect.`
);

// Second paragraph (separate, as in document)
drawParagraph(
  `It is clarified that the parking space areas may contains/includes plumbing, electrical wires, chambers, cutouts etc. and the Allottee shall have no objections for the same.`
);

 // ================= SECTION 3 =================
y -= 10;
page.drawText("3. Receipt of part consideration:", {
  x: margin,
  y,
  size: fontSize,
  font: bold,
});
y -= lineHeight;

// Full legal paragraph (exact wording)
drawParagraph(
  `We confirmed that we have received from you an amount of Rs.${parkingData?.paidAmt?.ocr || "_________"} /- as booking amount/advance payment on Refer Cost Sheet, through Cheque/NEFT/RTGS no. Refer Cost Sheet. The above payment received by me/us have been deposited in RERA Designated Collection Bank Account No.409002507119, RBL Bank Ltd., Camp Branch, Pune having IFS Code No. RATN0000157. In addition to the above bank account, we have opened in the same bank, RERA Designated Separate Bank Account and RERA Designated Transaction Bank Account having Account No.409002507126 and Account No.409002507133 respectively.`
);

  /// ================= SECTION 4 =================
y -= 10;
page.drawText("4. Disclosures of information:", {
  x: margin,
  y,
  size: fontSize,
  font: bold,
});
y -= lineHeight;

// Intro line
drawParagraph(
  "I/We have made available to you the following information namely: -"
);

// Point i)
drawParagraph(
  "i) The sanctioned plans, layout plans, along with specifications, approved by the Competent Authority are displayed at the Project site and has also been uploaded on MahaRERA website."
);

// Point ii)
drawParagraph(
  "ii) The stage wise time Schedule of completion of the Project, including the provisions for civic infrastructure like water, sanitation and electricity is as stated in Annexure – A attached herewith"
);

// Point iii)
drawParagraph(
  "iii) The Website address of MahaRERA is https://maharera.mahaonline.gov.in/#"
  
);


 // ================= SECTION 5 =================
y -= 10;
page.drawText("5. Encumbrances:", {
  x: margin,
  y,
  size: fontSize,
  font: bold,
});
y -= lineHeight;

drawParagraph(
  "I/We hereby confirm that the said unit is free from all encumbrances and I/We hereby further confirm that no encumbrances shall be created on the said unit."
);

// ================= SECTION 6 =================
y -= 10;
page.drawText("6. Further Payments:", {
  x: margin,
  y,
  size: fontSize,
  font: bold,
});
y -= lineHeight;

drawParagraph(
  "Further payments towards the consideration of the said unit shall be made by you, in the manner and at the times as well as on the terms and conditions as more specifically enumerated / stated in the Agreement for Sale to be entered into between ourselves and yourselves."
);

// ================= SECTION 7 =================
y -= 10;
page.drawText("7. Possession:", {
  x: margin,
  y,
  size: fontSize,
  font: bold,
});
y -= lineHeight;

drawParagraph(
  "The said unit shall be handed over to you on or before 31/12/2030 subject to the payment of the consideration amount of the said unit in the manner and at the times as well as per the terms and conditions as more specifically enumerated /stated in the Agreement for Sale to be entered into between ourselves and yourselves."
);

// ================= SECTION 8 =================
y -= 10;
page.drawText("8. Interest payment:", {
  x: margin,
  y,
  size: fontSize,
  font: bold,
});
y -= lineHeight;

drawParagraph(
  "In case of delay in making any payments, you shall be liable to pay interest at the rate which shall be the State Bank of India highest Marginal Cost of Lending Rate Plus Two Percent."
);

// ================= SECTION 9 =================
y -= 10;
page.drawText("9. Cancellation of Allotment:", {
  x: margin,
  y,
  size: fontSize,
  font: bold,
});
y -= lineHeight;

// Clause i)
drawParagraph(
  "i) In case you desire to cancel the booking an amount mentioned in the Table hereunder written* would be deducted and the balance amount due and payable shall be refunded to you without interest within 45 days from the date of receipt of your letter requesting to cancel the said booking."
);

// ---------- TABLE ----------
y -= 10;

const colWidths = [50, 300, 145];
const rowHeight = 22;
let tableX = margin;
let tableY = y;

// Table Header
const headers = [
  "Sr. No.",
  "If the letter requesting to cancel the booking is received",
  "Amount to be deducted*",
];

headers.forEach((text, i) => {
  page.drawRectangle({
    x: tableX,
    y: tableY,
    width: colWidths[i],
    height: rowHeight,
    borderWidth: 1,
    borderColor: rgb(0, 0, 0),
  });

  page.drawText(text, {
    x: tableX + 4,
    y: tableY + 6,
    size: 8,
    font: bold,
  });

  tableX += colWidths[i];
});

tableY -= rowHeight;

// Table Rows
const rows = [
  ["1.", "Within 15 days from issuance of the allotment letter;", "Nil;"],
  [
    "2.",
    "Within 16 to 30 days from issuance of the allotment letter;",
    "1% of the cost of the said unit;",
  ],
  [
    "3.",
    "Within 31 to 60 days from issuance of the allotment letter;",
    "1.5% of the cost of the said unit;",
  ],
  [
    "4.",
    "After 61 days from issuance of the allotment letter.",
    "2% of the cost of the said unit.",
  ],
];

rows.forEach((row) => {
  let x = margin;

  row.forEach((cell, i) => {
    page.drawRectangle({
      x,
      y: tableY,
      width: colWidths[i],
      height: rowHeight,
      borderWidth: 1,
      borderColor: rgb(0, 0, 0),
    });

    page.drawText(cell, {
      x: x + 4,
      y: tableY + 6,
      size: 8,
      font,
    });

    x += colWidths[i];
  });

  tableY -= rowHeight;

  // page break safety
  if (tableY < 60) {
    page = pdfDoc.addPage([595, 842]);
    tableY = height - 50;
  }
});

// Move y below table
y = tableY - 10;

// Footnote
drawParagraph(
  "* The amount deducted shall not exceed the amount paid by you towards consideration of the said unit as mentioned in the table above."
);

// Clause ii)
drawParagraph(
  "ii) In the event the amount due and payable referred in Clause 8 (i) above is not refunded within 45 days from the date of receipt of your letter requesting to cancel the said booking, you shall be entitled to receive the balance amount with interest calculated at the rate which shall be the State Bank of India highest Marginal Cost of Lending Rate Plus Two Percent."
);

// ================= SECTION 10 =================
y -= 10;
page.drawText("10. Other Payments:", {
  x: margin,
  y,
  size: fontSize,
  font: bold,
});
y -= lineHeight;

drawParagraph(
  "You shall make the payment of GST, Stamp Duty and Registration Charges, as applicable and such other payments as more specifically mentioned in the Agreement for Sale, the Proforma whereof is enclosed herewith in terms of Clause 10 hereunder written."
);

// ================= SECTION 11 =================
y -= 10;
page.drawText("11. Proforma of the Agreement for Sale and binding effect:", {
  x: margin,
  y,
  size: fontSize,
  font: bold,
});
y -= lineHeight;

drawParagraph(
  "The Proforma of the Agreement for Sale to be entered into between ourselves and yourselves is enclosed herewith for your ready reference. Forwarding the Proforma of the Agreement for Sale does not create a binding obligation on the part of ourselves and yourselves until compliance by yourselves of the mandate as stated in Clause 11."
);

// ================= SECTION 12 =================
y -= 10;
page.drawText("12. Execution and Registration of the Agreement for Sale:", {
  x: margin,
  y,
  size: fontSize,
  font: bold,
});
y -= lineHeight;

// Clause i)
drawParagraph(
  "i) You shall execute the Agreement for Sale and appear for registration of the same before the concerned Sub-Registrar within a period of 7 days from the date of issuance of this letter or within such period as may be communicated to you. The said period of 7 days can be further extended on our mutual understanding."
);
y -= 5;

// Bullet clause (as in document)
// ---- Bullet point ----
const bulletX = margin;
const bulletTextX = margin + 12;

// draw bullet symbol
page.drawText("•", {
  x: bulletX,
  y,
  size: fontSize,
  font,
});
 drawFooterNote(page, font, 8, width); 
// draw bullet paragraph text
drawParagraph(
  "In the event the booking is collected in stages and if allottee fails to pay the subsequent stage installment the promoter shall serve upon the allottee to pay the subsequent stage installment within days which if not complied, the promoter shall be entitled to cancel this allotment letter. On such cancellation of the allotment letter, the promoter shall be entitled to forfeit the amount paid by the allottee or such amount as mentioned in the table enumerated in clause 8 whichever is less. In no event to amount to be forfeited shall exceed the amount mentioned in the above referred table. Except for the above all the terms and conditions as enumerated in this allotment letter shall be applicable even for cases where booking amount is collected in stages.",
  
  { x: bulletTextX }
);
 
y -= 10;

// Clause ii)
drawParagraph(
  "ii) If you fail to execute the Agreement for Sale and appear for registration of the same before the concerned Sub-Registrar within the stipulated period 7 days from the date of issuance of this letter or within such period as may be communicated to you, I/We shall be entitled to serve upon you a notice calling upon you to execute the Agreement for Sale and appear for registration of the same within 15 (Fifteen) days, which if not complied, I/We shall be entitled to cancel this allotment letter and further I/We shall be entitled to forfeit an amount not exceeding 2% of the cost of the said unit and the balance amount if any due and payable shall be refunded without interest within 45 days from the date of expiry of the notice period."
);
y -= 10;

// Clause iii)
drawParagraph(
  "iii) In the event the balance amount due and payable referred in Clause 11 (ii) above is not refunded within 45 days from the date of expiry of the notice period, you shall be entitled to receive the balance amount with interest calculated at the rate which shall be the State Bank of India highest Marginal Cost of Lending Rate plus two percent."
);

// ================= SECTION 13 =================
y -= 10;
page.drawText("13. Validity of allotment letter:", {
  x: margin,
  y,
  size: fontSize,
  font: bold,
});
y -= lineHeight;

drawParagraph(
  "This allotment letter shall not be construed to limit your rights and interest upon execution and registration of the Agreement for Sale between ourselves and yourselves. Cancellation of allotment of the said unit thereafter, shall be covered by the terms and conditions of the said registered document."
);

// ================= SECTION 14 =================
y -= 10;
page.drawText("14. Headings:", {
  x: margin,
  y,
  size: fontSize,
  font: bold,
});
y -= lineHeight;

drawParagraph(
  "Headings are inserted for convenience only and shall not affect the construction of the various Clauses of this allotment letter."
);

// ================= AUTHORIZED SIGNATORY =================
// y -= 30;

// page.drawText(
//   "FOR VILAS JAVDEKAR INFINITEE DEVELOPERS PRIVATE LIMITED",
//   {
//     x: margin,
//     y,
//     size: fontSize,
//     font: bold,
//   }
// );

// y -= 30;

// page.drawText("Authorized Signatory", {
//   x: margin,
//   y,
//   size: fontSize,
//   font,
// });

// y -= lineHeight;

// page.drawText(
//   "(Name: Mr. Vaibhav Kothamire)                                Email Id: vaibhav.kothamire@javdekars.com",
//   {
//     x: margin,
//     y,
//     size: fontSize,
//     font,
//   }
// );

y -= lineHeight;

// page.drawText("Place: Pune", {
//   x: margin,
//   y,
//   size: fontSize,
//   font,
// });
// ================= CONFIRMATION & ACKNOWLEDGEMENT =================
y -= 30;

const text = "CONFIRMATION & ACKNOWLEDGEMENT";
const size = fontSize;

const italicFont = italic; // HelveticaOblique
const textWidth = italicFont.widthOfTextAtSize(text, size);

// draw italic text
page.drawText(text, {
  x: (width - textWidth) / 2,
  y,
  size,
  font: italicFont,
});

// draw underline
page.drawLine({
  start: { x: (width - textWidth) / 2, y: y - 2 },
  end: { x: (width - textWidth) / 2 + textWidth, y: y - 2 },
  thickness: 1,
  color: rgb(0, 0, 0),
});

y -= 20;

drawParagraph(
  "I/We have read and understood the contents of this allotment letter and the Annexure. I/We hereby agree and accept the terms and conditions as stipulated in this allotment letter."
);

y -= 30;

// Signature line
page.drawText("Signature: _______________", {
  x: margin,
  y,
  size: fontSize,
  font,
});
y -= lineHeight;

// Applicant name
page.drawText(
  `Name: ${parkingData?.name || ""} (Allottee/s)`,
  {
    x: margin,
    y,
    size: fontSize,
    font,
  }
);
y -= lineHeight;

// Co-applicant name (if exists)
page.drawText(
  `${parkingData?.applicants?.[1]?.applicant?.firstName || ""} ${parkingData?.applicants?.[1]?.applicant?.middleName ? parkingData.applicants[1].applicant.middleName : ""} ${parkingData?.applicants?.[1]?.applicant?.lastName || ""} (Allottee/s)`,
  {
    x: margin,
    y,
    size: fontSize,
    font,
  }
);

y -= lineHeight;

// Place
// page.drawText("Place: Pune", {
//   x: margin,
//   y,
//   size: fontSize,
//   font,
// });


  // ================= FOOTER NOTE =================
  drawFooterNote(page, font, 8, width); 

  return await pdfDoc.save();
};


  // -----------------------------
  // 2. Download PDF Button Handler
  // -----------------------------
  const handleDownloadPDF = async () => {
    const pdfBytes = await generateAllotmentLetterPDFBytes();
    const blob = new Blob([pdfBytes], { type: "application/pdf" });
    saveAs(blob, "Allotment_Letter.pdf");
  };

  const uploadPdfToBucket = async (pdfBytes, allotmentPaymentId) => {
    console.log("📌 uploadPdfToBucket called", { allotmentPaymentId });

    const timestamp = Date.now();
    const fileName = `allotment-${allotmentPaymentId}_${timestamp}.pdf`;
    const filePath = `allotments/${fileName}`;

    const blob = new Blob([pdfBytes], { type: "application/pdf" });

    const { data, error } = await supabase.storage
      .from("AllotmentLetter")
      .upload(filePath, blob, {
        contentType: "application/pdf",
        upsert: true,
      });

    if (error) {
      console.error("❌ Error uploading PDF:", error.message);
      throw error;
    }

    console.log("✅ Upload success:", data);

    // Construct public URL
    const publicUrl = `${process.env.REACT_APP_SUPABASE_BUCKET_PREFIX}AllotmentLetter/${filePath}`;
    console.log("📌 publicUrl constructed:", publicUrl);
    return publicUrl;
  };

  // const saveUrlToDb = async (allotmentPaymentId, pdfUrl) => {
  //   console.log("📌 saveUrlToDb triggered");
  //   console.log("allotmentPaymentId:", allotmentPaymentId);
  //   console.log("pdfUrl:", pdfUrl);

  //   const { data, error } = await supabase
  //     .from("EsignAllotment")
  //     .update({ generatedAllotmentUrl: pdfUrl })
  //     .eq("allotmentPaymentId", allotmentPaymentId);

  //   if (error) {
  //     console.error("❌ Error saving URL to DB:", error.message);
  //   } else {
  //     console.log("✅ Update success:", data);
  //   }
  // };

  // const handleEsignClick = async () => {
  //   setLoading(true);
  //   setError("");
  //   setSuccess("");

  //   try {
  //     // Step 1: Generate PDF bytes
  //     const pdfBytes = await generateAllotmentLetterPDFBytes();

  //     const filePath = "Allotment_Letter.pdf"; // adjust if backend saves differently

  //     // Step 3: Prepare payload

  //     const payload = {
  //       callback_url: "https://example.com?state=test", // your callback URL
  //       configReason: "Contract1", // reason for e-sign
  //       fullName: parkingData?.name  , // dynamically from allotment
  //       mobileNumber: "9503296704", //parkingData?.contactNumber ,
  //       userEmail:parkingData?.email || "harshadasawane23@gmail.com",
  //       filePath: "Allotment_Letter.pdf", // generated PDF path/name
  //       document_type: "Allotment_Letter", // document type
  //     };

  //     // Step 4: Call backend
  //     const response = await fetch("http://localhost:8050/eSignInitialize", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization:
  //           `Bearer ${process.env.REACT_APP_SUREPASS_TOKEN}`,
  //       },
  //       body: JSON.stringify(payload),
  //     });

  //     const result = await response.json();

  //     if (result.success) {
  //       setSuccess("E-sign initialized successfully!");
  //       const esignUrl = result.data.data.url;
  //       window.open(esignUrl, "_blank"); // open e-sign page
  //     } else {
  //       setError(result.message || "E-sign initialization failed.");
  //     }
  //   } catch (err) {
  //     setError("Error during e-sign: " + err.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // -----------------------------
  //  E-Sign Button Handler
  // -----------------------------

 
  // const saveUrlToDb = async (allotmentPaymentId, pdfUrl) => {
  //   console.log("📌 saveUrlToDb triggered");

  //   const { data, error } = await supabase
  //     .from("EsignAllotment")
  //     .upsert(
  //       {
  //         allotmentPaymentId,
  //         generatedAllotmentUrl: pdfUrl,
  //       },
  //       { onConflict: ["allotmentPaymentId"] }
  //     )
  //     .select()
  //     .single();

  //   if (error) {
  //     console.error("❌ Error saving URL to DB:", error.message);
  //     throw new Error("Failed to save PDF URL in DB");
  //   }

  //   console.log("✅ Row saved in DB:", data);
  //   return data; // return the saved row
  // };

const saveUrlToDb = async (allotmentPaymentId, pdfUrl) => {
  console.log("📌 saveUrlToDb triggered");

  if (!allotmentPaymentId || !pdfUrl) {
    console.error("❌ Missing allotmentPaymentId or pdfUrl");
    return;
  }

  // Step 1: Check if the record already exists
  const { data, error } = await supabase
    .from("EsignAllotment")
    .select("*")
    .eq("allotmentPaymentId", allotmentPaymentId)
    // .maybeSingle();  // Query to check if the record exists

  if (error) {
    console.error("❌ Error fetching data:", error.message);
    return; // Return early in case of error
  }

  console.log("Fetched record:", data);
  
  // Step 2: Handle the case where no record is found (insert new record)
  if (data === null || data.length === 0) {
    console.log("inside data null", data);
    
    console.log("No matching record found. Proceeding with insert.");

    const { data: insertData, error: insertError } = await supabase
      .from("EsignAllotment")
      .insert([
        {
          allotmentPaymentId,
          generatedAllotmentUrl: pdfUrl,  // Insert the generated URL
        },
      ]);

    if (insertError) {
      console.error("❌ Error inserting record:", insertError.message);
      return;  // Early return if there's an error inserting
    }

    console.log("✅ New record inserted in DB:", insertData);
    return insertData;  // Return the newly inserted data
  } else {
    // Step 3: If the record exists, update it
    console.log("Record found:", data);

    const { error: updateError } = await supabase
      .from("EsignAllotment")
      .update({
        generatedAllotmentUrl: pdfUrl,  // Update the generated URL
      })
      .eq("allotmentPaymentId", allotmentPaymentId);  // Match by allotmentPaymentId

    if (updateError) {
      console.error("❌ Error updating record:", updateError.message);
      return;  // Early return if there's an error updating
    }

    console.log("✅ Record updated in DB:", data);
    return data;  // Return the updated data
  }
};




  // const handleEsignClick = async () => {
  //   setLoading(true);
  //   setError("");
  //   setSuccess("");

  //   try {
  //     // Step 1: Generate PDF
  //     const pdfBytes = await generateAllotmentLetterPDFBytes();

  //     // Step 2: Upload to Supabase
  //     const pdfUrl = await uploadPdfToBucket(
  //       pdfBytes,
  //       allotment?.allotmentPaymentId
  //     );

  //     // Step 3: Save in DB
  //     await saveUrlToDb(allotment?.allotmentPaymentId, pdfUrl);

  //     // Step 4: Prepare payload for backend
  //     const payload = {
  //       callback_url: "https://example.com?state=test",
  //       configReason: "Contract1",
  //       fullName: parkingData?.name || "NA",
  //       mobileNumber: "9503296704",
  //       userEmail: parkingData?.email || "fallback@example.com",
  //       filePath: pdfUrl, // 👈 use uploaded Supabase URL
  //       document_type: "Allotment_Letter",
  //       allotmentPaymentId: allotment?.allotmentPaymentId,
  //     };

  //     // Step 5: Call backend
  //     const response = await fetch("http://localhost:8050/eSignInitialize", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(payload),
  //     });

  //     // const result = await response.json();
  //     // if (result.success) {
  //     //   setSuccess("E-sign initialized successfully!");
  //     //   window.open(result.data.data.url, "_blank");
  //     // } else {
  //     //   setError(result.message || "E-sign initialization failed.");
  //     // }

  //     const result = await response.json();

  //     // const result = { success: true };

  //     if (result.success) {
  //       setSuccess("E-sign initialized successfully!");

  //       // 🔎 Fetch latest eSignInitializedUrl from Supabase
  //       const { data, error } = await supabase
  //         .from("EsignAllotment")
  //         .select("eSignInitializedUrl")
  //         .eq("allotmentPaymentId", allotment?.allotmentPaymentId)
  //         .single();

  //       if (error) {
  //         console.error(
  //           "❌ Error fetching eSignInitializedUrl:",
  //           error.message
  //         );
  //         setError("E-sign initialized but failed to fetch URL from DB.");
  //         return;
  //       }

  //       if (data?.eSignInitializedUrl) {
  //         console.log("data", data);
  //         window.open(data.eSignInitializedUrl, "_blank");
  //       } else {
  //         setError("E-sign initialized but no URL found in DB.");
  //       }
  //     } else {
  //       setError(result.message || "E-sign initialization failed.");
  //     }
  //   } catch (err) {
  //     console.error("❌ E-sign error:", err);
  //     setError("Error during e-sign: " + err.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleEsignClick = async () => {
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      // Step 1: Generate PDF
      const pdfBytes = await generateAllotmentLetterPDFBytes();

      // Step 2: Upload to Supabase
      const pdfUrl = await uploadPdfToBucket(
        pdfBytes,
        allotment?.allotmentPaymentId
      );

      // Step 3: Save in DB (wait for confirmation)
      const savedRow = await saveUrlToDb(allotment?.allotmentPaymentId, pdfUrl);

      console.log("Saved row from DB:", savedRow);
      
      if (!savedRow[0]?.generatedAllotmentUrl) {
        setError("PDF URL not saved in DB. Cannot proceed with e-sign.");
        setLoading(false);
        return;
      }

      // Step 4: Prepare payload for backend
      const payload = {
        callback_url: "https://example.com?state=test",
        configReason: "Contract1",
        fullName: parkingData?.name || "NA",
        mobileNumber:(parkingData?.contactNumber).toString() || "",  //(parkingData?.contactNumber).toString() ||
        userEmail: parkingData?.email || "fallback@example.com",
         allotmentPaymentId: allotment?.allotmentPaymentId,
      };

      console.log("Payload before sending to backend:", payload);
      
      // Step 5: Call backend
      const response = await fetch(
        // "http://localhost:8050/eSignInitialize",
        // "https://vjsalessandbox.vjerp.com/api/eSignInitialize",
        `${process.env.REACT_APP_PAYMENT_LINK_URL}eSignInitialize`,
         {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      console.log("Response from backend:", response);
      
      const result = await response.json();

      if (result.success) {
        setSuccess("E-sign initialized successfully!");

        // 🔎 Fetch latest eSignInitializedUrl from DB
        const { data, error } = await supabase
          .from("EsignAllotment")
          .select("eSignInitializedUrl")
          .eq("allotmentPaymentId", allotment?.allotmentPaymentId)
          .single();

        if (error) {
          setError("E-sign initialized but failed to fetch URL from DB.");
          return;
        }

        if (data?.eSignInitializedUrl) {
          window.open(data.eSignInitializedUrl, "_blank");
        } else {
          setError("E-sign initialized but no URL found in DB.");
        }
      } else {
        setError(result.message || "E-sign initialization failed.");
      }
    } catch (err) {
      console.error("❌ E-sign error:", err);
      setError("Error during e-sign: " + err.message);
    } finally {
      setLoading(false);
    }
  };

 return (
  <div style={{ width: "100%" }}>
    {pdfUrl ? (
      <iframe
        src={pdfUrl + "#zoom=100&page=1"}
        title="Allotment Letter"
        style={{
          width: "100%",
          height: "70vh",
          border: "none",
        }}
      />
    ) : (
      <p style={{ textAlign: "center", padding: "20px" }}>
        Generating Allotment Letter...
      </p>
    )}
  </div>
);

};

export default PNRDAllotmentLetter;